<div class="text-center">
  <div style="margin-top: 50px; margin-bottom: 100px; text-align: left">
    @for (element of abovePage.elements; track element) {
      @if (element.type == 'header') {
        <h1>{{ element.value }}</h1>
      }
      @if (element.type == 'br') {
        <br />
      }
      @if (element.type == 'hr') {
        <hr />
      }
      @if (element.type == 'ul') {
        <ul>
          @for (el of element.elements; track el) {
            <li>{{ el.value }}</li>
          }
        </ul>
      }
      @if (element.type == 'p') {
        <p
          [ngClass]="controller.getClassObject(element, [])"
          >
          {{ element.value }}
        </p>
      }
    }
  </div>


  @for (module of modules; track module; let index = $index) {
    <div style="margin-top: -20px; margin-bottom: 0px; text-align: left">
      <h1 class="question-text">{{module.question}}</h1>
      @if (haveThumbnails) {
        <div class="rating header">
          <div class="rating-col"></div>
          <div class="rating-col">
            <div class="rating-type">Audio only</div>
            <div>Out of 10</div>
          </div>
          <div class="rating-col">
            <div class="rating-type">Video</div>
            <div>Out of 10</div>
          </div>
        </div>
      }
      @if (haveThumbnails) {
        @for (rating of module.ratings; track rating) {
          <ng-container>
            <div data-testid="rating-result-row" class="rating">
              <div class="rating-col">
                <img data-testid="rating-result-photo" src="{{baseUrl}}{{ rating.thumbnail }}" />
              </div>
              <div data-testid="rating-result-audio" class="rating-col">{{ rating.audio }}</div>
              <div data-testid="rating-result-video" class="rating-col">{{ rating.video }}</div>
            </div>
          </ng-container>
        }
      }
    </div>
  }


  <div style="margin-top: 50px; margin-bottom: 50px; text-align: left">
    @for (element of belowPage.elements; track element) {
      @if (element.type == 'header') {
        <h1>{{ element.value }}</h1>
      }
      @if (element.type == 'br') {
        <br />
      }
      @if (element.type == 'hr') {
        <hr />
      }
      @if (element.type == 'ul') {
        <ul>
          @for (el of element.elements; track el) {
            <li>{{ el.value }}</li>
          }
        </ul>
      }
      @if (element.type == 'p') {
        <p
          [ngClass]="controller.getClassObject(element, [])"
          >
          {{ element.value }}
        </p>
      }
    }
  </div>

  @if (loaded && bias == 'none') {
    <div>
      <div>
        <h1 class="text-left pull-left">No bias</h1>
        <div class="clearfix"></div>
      </div>
      <div class="text-left default-text">
        <p>
          You are unusual in that you had very little discernible bias. Of course
          this doesn’t mean you don’t have biases – we all do. It might mean that
          we weren’t able to detect them, perhaps because they related to traits
          we don’t measure, like sexual orientation. Or it might mean that you are
          able when scoring interview clips on a computer to overcome them
          completely.
        </p>
        <p>
          Either way, an impressive performance! Here are some general
          interviewing and management tips to keep you sharp.
        </p>
      </div>
    </div>
  }
  @if (loaded && bias == 'negative') {
    <div>
      <div>
        <h1 class="text-left pull-left">Negative biases</h1>
        <div class="clearfix"></div>
      </div>
      <div class="text-left default-text">
        <p>
          We found some negative biases in your responses (that is, you responded
          more negatively to certain groups of people in the video versus their
          audio answers than you did to others). Specifically, your responses appeared to reflect some bias toward {{ nbiasesString }}.
        </p>
      </div>
    </div>
  }
  @if (loaded && bias == 'positive') {
    <div>
      <div>
        <h1 class="text-left pull-left">Positive biases</h1>
        <div class="clearfix"></div>
      </div>
      <div class="text-left default-text">
        <p>
          We found some positive biases in your responses (that is, you responded
          more positively to certain groups of people in the video versus their
          audio answers than you did to others). Specifically, your responses appeared to reflect some bias toward {{ pbiasesString }}.
        </p>
      </div>
    </div>
  }
  @if (loaded && bias == 'mixed') {
    <div>
      <div>
        <h1 class="text-left pull-left">Positive and negative biases</h1>
        <div class="clearfix"></div>
      </div>
      <div class="text-left default-text">
        <p>
          We found some positive biases in your responses (that is, you responded
          more positively to certain groups of people in the video versus their
          audio answers than you did to others). Specifically, your responses appeared to reflect some bias toward {{ pbiasesString }}.
        </p>
        <p>
          We also found some negative biases in your responses (that is, you
          responded more negatively to certain groups of people in the video
          versus their audio answers than you did to others). Specifically, your responses appeared to reflect some bias toward {{ nbiasesString }}.
        </p>
      </div>
    </div>
  }

  <button
    id="finishedD"
    (click)="onComplete()"
    class="btn btn-outline-primary btn-outline hover active"
    >
    Next
  </button>
</div>

<app-progress-bar [progressValue]="controller.getProgress()"></app-progress-bar>
